module.exports = __webpack_public_path__ + "img/home_normal.e2d26627.svg";